import React from "react";

import ReactDOM from "react-dom/client";

import "./index.css";

import App from "./App";
import {
  SalesProvider
} from "./context/SalesContext";

import { HashRouter } from "react-router-dom";

import { ProductProvider } from "./context/ProductContext";

import { CustomerProvider } from "./context/CustomerContext";

import { ThemeProvider } from "./context/ThemeContext";

const root = ReactDOM.createRoot(
  document.getElementById("root")
);

root.render(
  <React.StrictMode>

    <ThemeProvider>

      <ProductProvider>

        <SalesProvider>

          <CustomerProvider>

            <HashRouter>

              <App />

            </HashRouter>

          </CustomerProvider>

        </SalesProvider>

      </ProductProvider>

    </ThemeProvider>

  </React.StrictMode>
);